import * as React from "react";
import { SVGProps } from "react";

const Propy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" {...props}>
    <path
      fill="#38a6fa"
      d="M49 47.11a2.09 2.09 0 0 1-2.1 2H16.1A2.11 2.11 0 0 1 14 47v-.7a8.33 8.33 0 0 1 1-3.2c1.5-2.8 4.3-4.8 8.3-6.2l12.3-4.1a16.83 16.83 0 0 0 5.2-3.1 14.8 14.8 0 0 0 5.3-11.2l.9.6a4.61 4.61 0 0 1 2 3.7v24.3Zm-10.5-28.7a7.2 7.2 0 0 1-2.4 5.5 11.68 11.68 0 0 1-2.8 1.8L21 29.81c-7.3 2.4-10.9 6.6-12.6 9.7a14.17 14.17 0 0 0-.8 1.8c0 .1-.1.1-.1.2v-18.6a4.72 4.72 0 0 1 2-3.7l16.8-11a3.69 3.69 0 0 1 3.9 0l8.3 5.5v4.7Zm18.1 28.3v-23.8a12.34 12.34 0 0 0-5.4-10l-5-3.3v-7.5A2.11 2.11 0 0 0 44.1 0h-3.3a2.05 2.05 0 0 0-2.1 2.1v2.5l-4.2-2.8a11.36 11.36 0 0 0-12.3 0l-16.8 11a12.07 12.07 0 0 0-5.4 10v23.8a9.89 9.89 0 0 0 1.6 5.8 8.25 8.25 0 0 0 3.4 3 13.78 13.78 0 0 0 5 1.3h36.7a11.75 11.75 0 0 0 5-1.3 8.53 8.53 0 0 0 3.5-3 10.93 10.93 0 0 0 1.4-5.7"
    />
  </svg>
);

export default Propy;
